import React from 'react';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'outline' | 'secondary' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  children: React.ReactNode;
}
const Button: React.FC<ButtonProps> = ({
  variant = 'default',
  size = 'md',
  fullWidth = false,
  children,
  className = '',
  ...props
}) => {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E84118] disabled:opacity-50 disabled:pointer-events-none';
  const variantStyles = {
    default: 'bg-[#E84118] text-white hover:bg-[#d13a16] border border-transparent',
    outline: 'bg-transparent text-gray-700 hover:bg-gray-100 border border-gray-300',
    secondary: 'bg-gray-100 text-gray-900 hover:bg-gray-200 border border-transparent',
    danger: 'bg-red-600 text-white hover:bg-red-700 border border-transparent'
  };
  const sizeStyles = {
    sm: 'text-xs px-3 py-1.5 rounded',
    md: 'text-sm px-4 py-2',
    lg: 'text-base px-5 py-2.5'
  };
  const widthStyle = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthStyle} ${className}`} {...props} data-id="element-177">
      {children}
    </button>;
};
export default Button;